<template>
  <div class="topup-manual">
    <div class="manual-card">
      <div class="manual-title">
        {{$t('paymentInfomation')}}
      </div>
      <div class="manual-tip">
        <!--<i class="fa fa-info-circle"></i>-->
        <md-icon name="info" size="sm"></md-icon>
        <span>
          {{ $t('manualTip') }}
        </span>
      </div>
      <div v-for="(item, index) in topupManuInfo" :key="index" class="account-item">
        <div class="label">{{ item.label }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>
    <div class="split-block"></div>
    <div class="manual-card">
      <div class="manual-title">
        {{ $t('howToPay') }}
      </div>
      <div class="row" v-for="(i, index) in stepList" :key="index">
        <div class="icon step-number">{{ i.stepNum }}</div>
        <div class="step-text">{{ i.stepText }}</div>
      </div>
    </div>
    <div class="split-block"></div>
    <div class="manual-card">
      <div class="manual-title">
        {{ $t('contactUs') }}
      </div>
      <div class="row" v-for="(i, index) in contactList" :key="index">
        <img :src="i.icon" class="icon contact-icon">
        <div class="contact-item">
          <div class="contact-label">{{ i.label }}</div>
          <div class="contact-value">{{ i.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Tabs } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        accountName: 'Account Name',
        accountNumber: 'Account Number',
        bankName: 'Bank Name',
        bankCode: 'Bank Code',
        paymentInfomation: 'Payment Information',
        manualTip: 'Only accept above Rp500.000.000',
        howToPay: 'How to pay?',
        step1: 'Transfer money to the account above.',
        step2: 'Your balance will be updated within 24 hours.',
        contactUs: 'If have any questions, please contact us:',
        whatsapp: 'Whatsapp:',
        email: 'E-mail:',
      },
      id: {
        accountName: 'Nama Pemilik Akun',
        accountNumber: 'No. Rekening',
        bankName: 'Nama Bank',
        bankCode: 'Kode Bank',
        paymentInfomation: 'Payment Information',
        manualTip: 'Only accept above Rp500.000.000',
        howToPay: 'Bagaimana cara membayar?',
        step1: 'Transfer uang ke akun di atas.',
        step2: 'Nominal Anda akan diperbarui dalam waktu 24 jam.',
        contactUs: 'Jika Anda memiliki pertanyaan, silahkan hubungi kami:',
        whatsapp: 'Whatsapp:',
        email: 'E-mail:',
      },
    },
  },
  components: {
    [Button.name]: Button,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      topupManuInfo: [
        { label: this.$t('accountName'), value: 'KREDIT PINTAR INDONESIA PT' },
        { label: this.$t('accountNumber'), value: '800152633300' },
        { label: this.$t('bankName'), value: 'CIMB Niaga' },
        { label: this.$t('bankCode'), value: '00022' },
      ],
      stepList: [
        { stepNum: '1', stepText: this.$t('step1') },
        { stepNum: '2', stepText: this.$t('step2') },
      ],
      contactList: [
        {
          icon: require('@/assets/image/icons/icon-whatsapp.png'),
          label: this.$t('whatsapp'),
          value: '081324887208',
        },
        {
          icon: require('@/assets/image/icons/icon-email.png'),
          label: this.$t('email'),
          value: 'pendanaan@kreditpintar.com',
        },
      ],
    }
  },
}
</script>

<style scoped lang="stylus">
.topup-manual {
  .manual-card {
    padding: 30px 20px;
  }
  .manual-title {
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: bold;
    color: #101010;
  }
  .manual-tip {
    font-size: 14px;
    width: fit-content;
    padding: 2px 8px 2px 2px;
    color: #2C2E38;
    border-radius: 8px;
    border: 1px solid rgba(44, 46, 56, 1);
    margin-bottom: 20px;
  }
  .account-item {
    margin-bottom: 20px;
    font-size: 14px;
    &:last-child {
      margin-bottom: 0;
    }
    .label {
      margin-right: 20px;
      color: #555;
      margin-bottom: 6px;
    }
    .value {
      color: #101010;
      font-weight: 500;
    }
  }
  .split-block {
    background-color: #f8f8f8;
    height: 6px;
  }
  .row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
    .icon {
      margin-right: 10px;
      &.step-number {
        background-color: color-primary;
        color: #fff;
        width: 18px;
        height: 18px;
        font-size: 8px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &.contact-icon {
        width: 18px;
        height: 18px;
      }
    }
    .contact-item {
      display: flex;
      justify-content: flex-start;
      font-size: 14px;
      .contact-label {
        font-weight: 500;
        margin-right: 5px;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
